export default __webpack_public_path__ + "static/media/OpenTaskIcon.edf7d9b5.svg";